module.exports = __webpack_public_path__ + "static/media/PortraitLeaderboard-10213new.af8e0bbc.jpg";